"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var styled_components_1 = require("styled-components");

var theme_1 = require("../theme");

var ComponentView = /*#__PURE__*/function () {
  function ComponentView(component, _ref) {
    var editor = _ref.editor,
        extension = _ref.extension,
        node = _ref.node,
        view = _ref.view,
        getPos = _ref.getPos,
        decorations = _ref.decorations;

    _classCallCheck(this, ComponentView);

    this.isSelected = false;
    this.component = component;
    this.editor = editor;
    this.extension = extension;
    this.getPos = getPos;
    this.decorations = decorations;
    this.node = node;
    this.view = view;
    this.dom = node.type.spec.inline ? document.createElement("span") : document.createElement("div");
    this.renderElement();
  }

  _createClass(ComponentView, [{
    key: "renderElement",
    value: function renderElement() {
      var dark = this.editor.props.dark;
      var theme = this.editor.props.theme || (dark ? theme_1.dark : theme_1.light);
      var children = this.component({
        theme: theme,
        node: this.node,
        isSelected: this.isSelected,
        isEditable: this.view.editable,
        getPos: this.getPos
      });
      react_dom_1.default.render(React.createElement(styled_components_1.ThemeProvider, {
        theme: theme
      }, children), this.dom);
    }
  }, {
    key: "update",
    value: function update(node) {
      if (node.type !== this.node.type) {
        return false;
      }

      this.node = node;
      this.renderElement();
      return true;
    }
  }, {
    key: "selectNode",
    value: function selectNode() {
      if (this.view.editable) {
        this.isSelected = true;
        this.renderElement();
      }
    }
  }, {
    key: "deselectNode",
    value: function deselectNode() {
      if (this.view.editable) {
        this.isSelected = false;
        this.renderElement();
      }
    }
  }, {
    key: "stopEvent",
    value: function stopEvent() {
      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.dom) {
        react_dom_1.default.unmountComponentAtNode(this.dom);
      }

      this.dom = null;
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation() {
      return true;
    }
  }]);

  return ComponentView;
}();

exports.default = ComponentView;